import React from 'react';
import PropTypes from 'prop-types';
import { InfoNoteStyled } from './InfoNote.styled';

export const InfoNote = ({ children, variant = 'info', ...props }) => {
  return (
    <InfoNoteStyled variant={variant} {...props}>
      {children}
    </InfoNoteStyled>
  );
};

InfoNote.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
};
